import { render } from "./DashboardRegulations.vue?vue&type=template&id=55986f62"
import script from "./DashboardRegulations.vue?vue&type=script&lang=js"
export * from "./DashboardRegulations.vue?vue&type=script&lang=js"

import "./DashboardRegulations.vue?vue&type=style&index=0&id=55986f62&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__